export const customTextOption = _TL_('Custom text');

export const callToActionOptions = [
  _TL_('Act now'),
  _TL_('Apply now'),
  _TL_('Bet now'),
  _TL_('Bid now'),
  _TL_('Book a car'),
  _TL_('Book hotel'),
  _TL_('Book now'),
  _TL_('Build now'),
  _TL_('Buy now'),
  _TL_('Chat now'),
  _TL_('Compare'),
  _TL_('Contact us'),
  _TL_('Dealers'),
  _TL_('Directions'),
  _TL_('Donate'),
  _TL_('Download'),
  _TL_('Email now'),
  _TL_('Enroll now'),
  _TL_('File now'),
  _TL_('Find job'),
  _TL_('Find store'),
  _TL_('Free play'),
  _TL_('Free quote'),
  _TL_('Free trial'),
  _TL_('Get coupon'),
  _TL_('Get deals'),
  _TL_('Get demo'),
  _TL_('Get offer'),
  _TL_('Get quote'),
  _TL_('Go to demo'),
  _TL_('Join now'),
  _TL_('Learn more'),
  _TL_('Listen now'),
  _TL_('Log in'),
  _TL_('Order now'),
  _TL_('Play game'),
  _TL_('Play now'),
  _TL_('Post job'),
  _TL_('Register'),
  _TL_('Renew now'),
  _TL_('Rent a car'),
  _TL_('Rent now'),
  _TL_('Reorder'),
  _TL_('Reserve'),
  _TL_('Save now'),
  _TL_('Schedule'),
  _TL_('See demo'),
  _TL_('See menu'),
  _TL_('See models'),
  _TL_('See offer'),
  _TL_('See offers'),
  _TL_('See sale'),
  _TL_('Sell now'),
  _TL_('Shop now'),
  _TL_('Showtime'),
  _TL_('Sign in'),
  _TL_('Sign up'),
  _TL_('Start now'),
  _TL_('Subscribe'),
  _TL_('Switch now'),
  _TL_('Test drive'),
  _TL_('Try now'),
  _TL_('View cars'),
  _TL_('View demo'),
  _TL_('Visit plans'),
  _TL_('Visit store'),
  _TL_('Vote now'),
  _TL_('Watch'),
  _TL_('Watch more'),
  _TL_('Watch now'),
];
